import styled from 'styled-components'

export const CompactHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;

  /* 한 줄일 때 */
  &[style*="row"] {
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 12px;
  }

  /* 두 줄일 때 */
  &[style*="column"] {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    &[style*="row"] {
      padding: 0 8px;
    }
  }
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  width: 100%;
  padding: 0 12px;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 100%;
  padding: 0 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 50%, #0f0f0f 100%);
  position: relative;

  /* 서브 라인 느낌의 그림자 효과 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
  }

  @media (max-width: 768px) {
    padding: 0 8px;
    height: 32px;
  }

  @media (max-width: 480px) {
    height: 28px;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 2px;
  }
`

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  min-width: 80px;
`

export const CenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  margin: 0 8px;
  overflow: visible;
  min-width: 0;

  @media (max-width: 1400px) {
    margin: 0 6px;
  }

  @media (max-width: 1200px) {
    margin: 0 4px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    gap: 4px;
  }
`

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: visible;
  flex: 1;

  .ant-menu {
    background: transparent;
    border: none;
    line-height: 38px;
    overflow: visible !important;
    width: 100% !important;
    max-width: none !important;
    flex: 1;

    .ant-menu-overflow {
      overflow: visible !important;
    }

    .ant-menu-overflow-item {
      display: flex !important;
    }

    .ant-menu-item {
      position: relative;
      margin: 0 1px;
      padding: 0 6px;
      color: rgba(255, 255, 255, 0.85);
      border-radius: 4px;
      transition: all 0.2s ease;
      font-size: 13px;

      &:hover {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.08);
      }

      &.ant-menu-item-selected {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.15);

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 20px;
          height: 2px;
          background: #1890ff;
          border-radius: 1px;
        }
      }
    }

    .ant-menu-submenu {
      .ant-menu-submenu-title {
        margin: 0 1px;
        padding: 0 6px;
        color: rgba(255, 255, 255, 0.85);
        border-radius: 4px;
        transition: all 0.2s ease;
        font-size: 13px;

        &:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.08);
        }
      }

      &.ant-menu-submenu-active,
      &.ant-menu-submenu-open {
        .ant-menu-submenu-title {
          color: #1890ff;
          background: rgba(24, 144, 255, 0.15);
        }
      }
    }
  }
`

export const ProfileButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  height: 28px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .profile-icon {
    color: rgba(255, 255, 255, 0.9);
    font-size: 11px;
  }

  .profile-text {
    color: rgba(255, 255, 255, 0.9);
    font-size: 10px;
    font-weight: 500;
    line-height: 1.2;
  }

  .dropdown-arrow {
    color: rgba(255, 255, 255, 0.7);
    font-size: 9px;
  }
`

export const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 1200px) {
    gap: 3px;
  }

  @media (max-width: 768px) {
    gap: 2px;
  }

  @media (max-width: 480px) {
    gap: 1px;
    justify-content: flex-start;
  }
`

export const CompactButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  font-size: 10px;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.25);
  }

  &.active {
    background: rgba(24, 144, 255, 0.2);
    border-color: rgba(24, 144, 255, 0.4);
    color: #1890ff;
  }

  &.green {
    background: rgba(82, 196, 26, 0.2);
    border-color: rgba(82, 196, 26, 0.4);
    color: #52c41a;
  }

  .compact-icon {
    font-size: 11px;
  }

  &.icon-only {
    width: 28px;
    padding: 0;
    gap: 0;
  }

  @media (max-width: 1200px) {
    font-size: 9px;
    padding: 0 4px;
    gap: 2px;

    .compact-icon {
      font-size: 10px;
    }
  }

  @media (max-width: 1024px) {
    font-size: 8px;
    padding: 0 3px;

    .compact-icon {
      font-size: 9px;
    }
  }
`

export const MobileMenuButton = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .menu-icon {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    display: flex;
  }
`